import axiosInstance from './axiosInstance';

const representationService = {
  list: (params = {}) =>
    axiosInstance.get('/admin/representations', { params }),

  listCountries: (params = {}) =>
    axiosInstance.get('/admin/representations/countries', { params }),

  getById: (id) =>
    axiosInstance.get(`/admin/representations/${id}`),

  create: (data) =>
    axiosInstance.post('/admin/representations', data),

  update: (id, data) =>
    axiosInstance.put(`/admin/representations/${id}`, data),

  remove: (id) =>
    axiosInstance.delete(`/admin/representations/${id}`),
};

export default representationService;
